import React, { useEffect, useRef } from "react";
import "./site.css";
import "./toast.css";
import "./tracking.css";
import "./photo-slide.css";
import "./invoice-print.css";
import "./fabric.css"
import { createTheme, loadTheme, Customizer } from "@fluentui/react";
import { Routes, Route } from "react-router-dom";
import { Authentication } from "./components/common/views/Authentication";
import FooterView from "./components/common/views/FooterView";
import MenuView from "./components/common/views/MenuView";
import GeneralPolicy from "./components/home/pages/GeneralPolicy.page";
import PricePolicy from "./components/home/pages/PricePolicy.page";
import Privacy from "./components/home/pages/Privacy.page";
import Term from "./components/home/pages/Terms.page";
import InvoiceLabel from "./components/invoices/pages/InvoiceLabel.page";
import ScanInvoicePrint from "./components/invoices/pages/ScanInvoicePrint.page";
import Order from "./components/orders/pages/Order.page";
import OrderAdmin from "./components/orders/pages/OrderAdmin.page";
import Home from "./components/home/pages/Home.page";
import LoginPage from "./components/accounts/pages/Login.page";
import { useHomeVM } from "./components/home/viewmodels/HomeVM";
import NewFeed from "./components/newfeeds/pages/NewFeed.page";
import Invoice from "./components/invoices/pages/Invoice.page";
import Payment from "./components/payments/pages/Payment.page";
import SignupPage from "./components/accounts/pages/signup.page";
import ForgotPasswordPage from "./components/accounts/pages/ForgotPassword.page";
import ChangePasswordPage from "./components/accounts/pages/ChangePassword.page";
import CustomerProfile from "./components/customers/pages/CustomerProfile.page";
import CustomerContact from "./components/customers/pages/CustomerContact.page";
import UserDeletion from "./components/home/pages/UserDeletion.page";

const customTheme = createTheme({
    fonts: {
        medium: {
            fontFamily: "Segoe UI"
        },
    },
});

const myTheme = createTheme({
    palette: {
        themePrimary: '#fde354',
        themeLighterAlt: '#0a0801',
        themeLighter: '#282002',
        themeLight: '#4c3c04',
        themeTertiary: '#977808',
        themeSecondary: '#deb00b',
        themeDarkAlt: '#fdce25',
        themeDark: '#fdd546',
        themeDarker: '#fee077',
        neutralLighterAlt: '#ffffff',
        neutralLighter: '#ffffff',
        neutralLight: '#ffffff',
        neutralQuaternaryAlt: '#ffffff',
        neutralQuaternary: '#ffffff',
        neutralTertiaryAlt: '#ffffff',
        neutralTertiary: '#bab8b7',
        neutralSecondary: '#a3a2a0',
        neutralSecondaryAlt: '#a3a2a0',
        neutralPrimaryAlt: '#8d8b8a',
        neutralPrimary: '#323130',
        neutralDark: '#605e5d',
        black: '#494847',
        white: 'white'
    }
});

loadTheme(myTheme);

const App: React.FC = () => {
    const hasLoaded = useRef(false);
    Authentication.setupAjaxAuthorization();

    const homeVM = useHomeVM();

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        homeVM.onLoad();
    }, [homeVM]);

    const url = window.location.href.toLowerCase();
    const isPrint = url.indexOf("/label") > -1;

    var cssHomepage = "home-page-container";
    var cssHomeBody = "home-page-body";

    if (isPrint) {
        cssHomepage = "center";
        cssHomeBody = "";
    }

    const routes = () => {
        return <div className="pv-10">
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/general-policy" element={<GeneralPolicy />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/price-policy" element={<PricePolicy />} />
                <Route path="/terms" element={<Term />} />
                <Route path="/userDeletion" element={<UserDeletion />} />

                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/change-password" element={<ChangePasswordPage />} />

                <Route path="/profiles" element={<CustomerProfile />} />
                <Route path="/contacts" element={<CustomerContact />} />

                <Route path="/orders" element={<Order />} />
                <Route path="/invoices" element={<Invoice />} />
                <Route path="/payments" element={<Payment />} />
                <Route path="/invoice-print" element={<ScanInvoicePrint />} />
                <Route path="/invoice-prints">
                    <Route path="label/:ids" element={<InvoiceLabel />} />
                </Route>
                <Route path="/admin-orders" element={<OrderAdmin />} />
                <Route path="/admin-new-feeds" element={<NewFeed />} />
                {/*<Route path="/products">*/}
                {/*    <Route index element={<Products />} />*/}
                {/*    <Route path="add" element={<AddProduct />} />*/}
                {/*    <Route path="edit/:id" element={<EditProduct />} />*/}
                {/*    <Route path="delete/:id" element={<DeleteProduct />} />*/}
                {/*</Route>*/}
            </Routes>
        </div>;
    }

    return (
        <Customizer settings={{ theme: customTheme }}>
            <div className={cssHomepage} id="top-page">
                <div className={cssHomeBody}>
                    {!isPrint && <div>
                        <MenuView banners={homeVM.banners} />
                    </div>}

                    <div style={{ minHeight: "70vh" }}>
                        {routes()}
                    </div>

                    {!isPrint && <div>
                        <FooterView contacts={homeVM.contacts} />
                    </div>}
                </div>
            </div>
        </Customizer>
    );
};

export default App;